<template>
	<div class="panel_shouyin">
		<div class="titleLine">
			<el-row>
				<el-col :span="6">
					
				</el-col>
				<el-col :span="6">
					
				</el-col>
				<el-col :span="2" :offset="22">
					<el-button @click="back" size="mini">返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="con">
			<div class="L">
				<div class="label" style="font-size: 16px;font-weight: bold;margin-bottom: 8px;"><span style="color:#9F0700;margin-right: 5px;">*</span>洗美卡升级</div>
				<div class="label">现洗美卡：</div>
				<div style="padding:0 0 10px 0;font-size: 14px;">
					<div style="padding:5px 0;">· {{curRow.service_name}} {{curRow.service_object_name}}</div>
					<div style="padding:5px 0;">· 剩余次数：{{curRow.surplus_count}}/{{curRow.total_count}}次</div>
				</div>
				<div class="label">升级为：</div>
				<el-input :value="skuItem.service_name?skuItem.service_name+' '+skuItem.service_objectName:''" disabled size="mini" style="width:210px;margin-bottom:20px;"></el-input>
				<div class="label">升级次数：</div>
				<el-select v-model="times" @change="changeTimes" :disabled="!skuItem.detail_id" placeholder="请选择" size="mini" style="width:210px;margin-bottom:20px;">
					<el-option v-for="item in [{label:'升级剩余次数',value:'also'},{label:'升级为新卡',value:'all'}]" :key="item.value" :label="item.label"
					:value="item.value"></el-option>
				</el-select>
				<div style="padding:0 0 2px 0;font-size: 14px;">
					<div style="padding:5px 0;">· {{curRow.service_name}} {{curRow.service_object_name}}</div>
					<div style="padding:5px 0;">· 剩余次数：{{curRow.surplus_count}}/{{curRow.total_count}}次</div>
					<div style="padding:4px 0 20px 0;">· 价格：{{paidMoney}}</div>
					<div v-if="skuItem.detail_id">
						<div style="padding:5px 0;">· {{skuItem.service_name}} {{skuItem.service_objectName}}</div>
						<div style="padding:5px 0;">· 剩余次数：{{times==='also'?curRow.surplus_count:goodsItem.total_count}}/{{goodsItem.total_count}}次</div>
						<div style="padding:4px 0 20px 0;">· 价格：{{times==='also'?$public.cheng(skuItem.price,curRow.surplus_count):skuItem.total_price}}</div>
					</div>
					<div v-else>
						<div style="padding:5px 0;">· 请选择新卡</div>
						<div style="padding:5px 0;">· 剩余次数：--</div>
						<div style="padding:4px 0 20px 0;">· 价格：--</div>
					</div>
					<div v-if="skuItem.detail_id" style="padding:4px 0 20px 0;">
						· 需补差价：
						<span v-if="times==='also'">{{$public.jian($public.cheng(skuItem.price,curRow.surplus_count),paidMoney)}}</span>
						<span v-if="times==='all'">{{$public.jian(skuItem.total_price,paidMoney)}}</span>
					</div>
					<div v-else style="padding:4px 0 20px 0;">· 需补差价：--</div>
				</div>
				<div class="label">销售人员：</div>
				<el-select v-model="saleManIdList" @change="changeSaleManIdList" multiple filterable placeholder="请选择" size="mini" style="width:210px;margin-bottom:20px;">
					<el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
					:value="item._id+','+item.basic_info.nick_name"></el-option>
				</el-select>
			</div>
			<div class="R">
				<div>
					<el-row>
					</el-row>
					<div v-for="(item,index) in serviceList" :key="index">
						<div style="font-size: 16px;font-weight: bold;padding:10px 20px 0;">{{item.title}}</div>
						<div class="roomBox">
							<div class="room" :class="[skuItem.detail_id===itemServiceItem.detail_id?'active':'']" v-for="(itemServiceItem,indexServiceItem) in item.service_details" :key="indexServiceItem" @click="changeService(item,itemServiceItem)">
								<div class="mask" v-if="!isCanUse(item,itemServiceItem)"></div>
								<!-- <div class="tip" v-if="isWeight(itemServiceItem)">推荐</div> -->
								<!-- <img class="checked"
								v-if="skuItem.detail_id===itemServiceItem.detail_id"
								src="../../../../assets/img/bottomRightChecked.png"
								>
								<img class="checked"
								v-else
								src="../../../../assets/img/bottomRightNoChecked.png"
								> -->
								<div class="roomName">
									<!-- <div>{{itemServiceItem.service_name}}</div> -->
									<div>{{itemServiceItem.service_objectName}}</div>
								</div>
								<div class="roomPrice">￥{{itemServiceItem.total_price}}/{{item.total_count}}次</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				// 购买次数
				times:'',
				// 销售人员
				saleManIdList:[],
				staffList:[],
				// 洗澡卡
				goodsItem:{},
				skuItem:{},
				serviceList:[],
				// 抵扣金额
				paidMoney:0,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
			curRow(){
				return this.$store.state.xizaoka.curRow;
			},
			addParams(){
				return this.$store.state.xizaokaUpdate.addParams;
			},
		},
		mounted(){
			this.paidMoney = this.$public.cheng(this.curRow.unit_price,this.curRow.surplus_count)
			this.getStaffList();
			this.getServiceList()
		},
		methods: {
			// 返回
			back(){
				this.$store.commit('xizaoka/set_type','list')
				this.goodsItem = {}
				this.skuItem = {}
				this.addParams.goodsId = ''
				this.addParams.goodsItem = this.goodsItem
				this.addParams.goodsItem.goodsName = ''
				this.addParams.serviceId = ''
				this.addParams.serviceItem = this.skuItem
				this.addParams.serviceItem.serviceName = ''
				this.$store.commit('xizaokaUpdate/set_addParams',this.addParams)
				this.$store.commit('xizaokaUpdate/set_money',0)
			},
			// 修改次数
			changeTimes(){
				this.$store.commit('xizaokaUpdate/set_times',this.times)
				if(this.times==='also'){
					this.$store.commit('xizaokaUpdate/set_money',this.$public.jian(this.$public.cheng(this.skuItem.price,this.curRow.surplus_count),this.paidMoney))
				}else if(this.times==='all'){
					this.$store.commit('xizaokaUpdate/set_money',this.$public.jian(this.skuItem.total_price,this.paidMoney))
				}
			},
			// 服务项目
			changeService(serviceItem,goodsItem){
				if(!this.isCanUse(serviceItem,goodsItem)) return ;
				this.goodsItem = serviceItem;
				this.skuItem = goodsItem;
				
				this.addParams.goodsId = goodsItem.detail_id
				this.addParams.goodsItem = goodsItem
				this.addParams.goodsItem.goodsName = goodsItem.service_name+'-'+goodsItem.service_objectName
				
				this.addParams.serviceId = serviceItem.virtualId
				this.addParams.serviceItem = serviceItem
				this.addParams.serviceItem.serviceName = serviceItem.title
				
				this.$store.commit('xizaokaUpdate/set_addParams',this.addParams)
				if(this.times==='also'){
					this.$store.commit('xizaokaUpdate/set_money',this.$public.jian(this.$public.cheng(goodsItem.price,this.curRow.surplus_count),this.paidMoney))
				}else if(this.times==='all'){
					this.$store.commit('xizaokaUpdate/set_money',this.$public.jian(goodsItem.total_price,this.paidMoney))
				}
			},
			getServiceList(){
				let params = {
					"keyword": "",
					"applytype": this.curRow.apply_type, // 应用分类 0:通用 1:猫 2:犬
					"categoryId": this.curRow.card_category._id,  // 分类id，第三级
					"status": 1, // 虚拟卡状态 1启用；0未启用
					"weight": -1,  // 宠物体重
					"pageIndex": 1,
					"pageSize": 500
				}
				let loading = this.$loading()
				this.$http.post('/api/Product/VirtualCard/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.serviceList = res.data.data
					}
				})
			},
			// 销售人员
			changeSaleManIdList(){
				this.$store.commit('xizaokaUpdate/set_saleManIdList',this.saleManIdList)
			},
			getStaffList() {
				let params = {
					"keyword": '',
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/BathStaffList', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
					}
				})
			},
			isCanUse(goodsItem,skuItem){
				console.log(this.curRow,this.curRow.level,this.curRow.weight_max,this.curRow.weight_min)
				console.log(goodsItem,skuItem)
				if(this.curRow.level>goodsItem.level){
					return false;
				}else{
					if(this.curRow.weight_max<=skuItem.weight_detail.max_weight){
						return true;
					}else{
						return false;
					}
				}
				
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;
	padding-bottom: 60px;
	box-sizing: border-box;
	position: relative;
	.titleLine{
		width:100%;
		background-color: #fff;
		height: 44px;
		padding:8px 8px;
		box-sizing: border-box;
		margin-bottom: 4px;
		position: absolute;
		z-index: 1;
	}
	.con{
		display: flex;padding:30px 0px 100px 0px;background-color: #fff;width:100%;height: 100%;box-sizing: border-box;padding-top:50px;position: absolute;top:0;
		.L{
			width:245px;border-right: 1px solid #f5f5f5;flex-shrink: 0;box-sizing: border-box;padding-left:20px;padding-right: 10px;
			.label{
				font-size: 14px;padding-bottom:10px;
			}
			.xmjBox{
				.xmjItem{
					position: relative;width:123px;box-sizing: border-box;height: 40px;text-align: center;line-height: 38px;color:#000;font-size: 14px;background-color: #E8E8E8;border-radius: 2px;margin-top:15px;margin-left:20px;border:1px solid transparent;cursor: pointer;
					&.active{
						background-color: #E3F2FF;border-color:#1890FF;
					}
					.checked{
						position: absolute;right:0;bottom:0;width:26px;height: 13px;text-align: center;color:#fff;
					}
				}
			}
		}
		.R{
			width:100%;height: 100%;overflow: auto;
			&::-webkit-scrollbar {
				width: 4px;
				// height: 4px;
			}
			.col{
				display: flex;
				align-items: center;
				padding-bottom:15px;
				.RLabel{
					font-size: 14px;
					color:#6E6E6E;
					text-align: right;
					line-height: 28px;
				}
			}
			.roomBox{
				display: flex;padding:10px 30px;flex-wrap: wrap;
				.room{
					position: relative;width:184px;height: 101px;border:1px solid #CDCDCD;box-sizing: border-box;background-color: #FFF;margin:6px 6px;text-align: center;cursor: pointer;border-radius: 4px;color:#999;overflow: hidden;
					.mask{
						position: absolute;top:-2px;left:-2px;z-index: 10;width:184px;height: 101px;background-color: rgba(0,0,0,.5);border-radius: 4px;
					}
					.tip{
						position: absolute;top:-1px;left:-1px;width:55px;height: 20px;text-align: center;color:#fff;background-color: $mainColor;font-size: 12px;line-height: 22px;z-index: 10;
					}
					.checked{
						position: absolute;right:-1px;bottom:-1px;width:40px;height: 18px;text-align: center;color:#fff;
					}
					.roomName{
						font-size: 16px;padding-top:23px;line-height: 20px;height: 40px;
					}
					.roomPrice{
						font-size: 14px;padding-top:0px;
					}
					&.active{
						border-color:$mainColor;color:$mainColor;
					}
				}
			}
		}
	}
}
</style>
